export const tr = {
    'header-caption-cpc':
        'Anahtar sözcük seçme aracını kullanarak reklam grubunuz için anahtar sözcükler ve negatif anahtar sözcükler ekleyebilirsiniz',
    'header-caption-cpm': 'Anahtar sözcük seçme aracı, reklam grubunuz için anahtar sözcük seçimini kolaylaştırır',
    'header-title': 'Sözcük grubu seçimi',
    'help-link': 'anahtar sözcük seçimi hakkında daha fazla bilgi'
};
